module.exports = __webpack_public_path__ + "static/media/26UNRWA8.a2dabcef.jpg";